import { status } from 'constants/general';
import { initialCommonState } from 'redux/initialStates';
import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };

    case commonActionTypes.FETCH_ALL_LABS:
      return {
        ...state,
        labsList: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_ALL_LABS_SUCCESS:
      return {
        ...state,
        labsList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_ALL_LABS_FAIL:
      return {
        ...state,
        labsList: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_ALL_CHEMISTS:
      return {
        ...state,
        chemistsList: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_ALL_CHEMISTS_SUCCESS:
      return {
        ...state,
        chemistsList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_ALL_CHEMISTS_FAIL:
      return {
        ...state,
        chemistsList: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_ALL_USERS:
      return {
        ...state,
        usersList: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        usersList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_ALL_USERS_FAIL:
      return {
        ...state,
        usersList: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION: {
      return {
        ...state,
        uploadContentSubmission: {
          status: status.FETCHING,
        },
      };
    }

    case commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION_SUCCESS: {
      return {
        ...state,
        uploadContentSubmission: {
          status: status.SUCCESS,
        },
      };
    }

    case commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION_FAIL: {
      return {
        ...state,
        uploadContentSubmission: {
          status: status.FAIL,
        },
      };
    }

    default:
      return state;
  }
};

export default commonReducer;
